<div class="okta-container">
  <div class="row okta-wrapper">
    <div class="okta-form-row">
      <div class="row logo-holder">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 logo-block">
          <img class="app-logo" src="/assets/images/{{websiteName}}/LogoNew.png" alt="" />
        </div>
      </div>
      <div class="row box-container">
        <form novalidate class="form-info" (ngSubmit)="onSecurityQuestionSubmit()">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <p class="exp-message">Answer Recovery Question Challenge</p>
            <div class="has-error okta-error" *ngIf="security.errorMessage">
              <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
              <p class="show-message">
                <span title="{{security.errorMessage}}">{{security.errorMessage}}</span>
              </p>
            </div>
            <ul class="form-grid">
              <li>
                <label>{{security.question}}</label>
              </li>
              <li>
                <mat-form-field>
                  <input id="password" matInput name="answer" type="password" required placeholder="Answer" [(ngModel)]="security.answer" parAutoFocus>
                </mat-form-field>
              </li>
              <li>
                <div class="okta-action-buttons">
                  <button id="btn-cancel" type="button" mat-raised-button color="accent" (click)="onCancelClick()">Back To Home</button>
                  <button id="btn-submit" type="submit" mat-raised-button color="accent">{{security.buttonAction}}</button>
                </div>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>